
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Patient } from "../../../../domain/patient";
import { ModelEditableMixin } from "../../../system/mixins";
import { PatientViewerMixin } from "../../viewers/mixins";

@Component({
})
export default class PatientFinderMixin extends Mixins(ModelEditableMixin, PatientViewerMixin) {
  @Prop()
  patientNo: string;

  data(): any {
    return {
      edittingId: this.patientNo ? this.patientNo : "",
      patient: null as Patient,
      isFinding: false,
    };
  }
  edittingId: string;
  patient: Patient;
  isFinding: boolean;

  get isFound(): boolean {
    return !this.isFinding && !!this.patient;
  }

  get isNumberOnly(): boolean {
    return this.$configuration.behavior.patient.id.isNumberOnly;
  }

  get inputType(): string {
    return this.isNumberOnly ? "number" : "text";
  }

  @Watch("patientNo")
  onPatientFinderPatientNoUpdated(newValue: string, oldValue: string) {
    this.edittingId = newValue ? newValue : "";
  }

  @Watch("editingSource")
  onPatientFinderEditingSourceUpdated(newValue: Patient, oldValue: Patient) {
    this.patient = newValue;
  }

  clearPatient(): void {
    this.edittingId = "";
    this.patient = null;
  }

  findPatient(): void {
    if (!this.edittingId) {
      this.$warn("入力チェック", "患者IDを入力してください。");
      return;
    }
    this.isFinding = true;
    const repository = DomainRegistry.patient.getPatientRepository();
    repository.getEntity(this.edittingId)
      .then(p => {
        this.patient = p;
        this.isFinding = false;
      })
      .catch(e => {
        console.error(e);
        this.clearPatient();
        this.isFinding = false;
        this.$warn(
          "患者番号不正",
          "入力された患者番号に該当する患者が見つかりませんでした。",
          e,
        );
      });
  }

  async findPatientByName(): Promise<void> {
    this.isFinding = true;
    const result = await this.$commonDialogs.patient.finder.showNameSearch();
    if (result) {
      this.patient = result;
      this.edittingId = result.id;
    }
    this.isFinding = false;
  }

  selectPatient(): void {
    this.editingSource = this.patient;
  }
}
